/// <reference path="holiday.module.ts" />
/// <reference path="../../components/common/holiday.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Holiday {
    class HolidayController extends Meevo.Components.CommonClasses.CommonControllerBase {
    // statically inject constructor resources
    static $inject = [
      "meevo.AppSettings",
      "meevo.components.common.BusinessInfoDataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',

      "meevo.components.busy.BusyService"];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected dataService: Meevo.Components.Common.HolidayDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

      protected busyService: Meevo.Components.Busy.IBusyService
      ) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      this.createContext();
    }

    createContext(): void {
      let vm = this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.BUSINESSINFO_HOLIDAYS).then(() => {
        vm.busyService.stop();
        vm.context = new HolidayContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, this.trackingService, this.$rootScope);
        super.createContext();
      });
    }
  }

    angular.module("meevo.plugins.holiday")
      .controller("meevo.plugins.holiday.HolidayController", HolidayController);
}
